<template>
    <div>
        <div class="row pl-3 pr-1 data-row mx-0" :style="rowDetail ? 'border-bottom: none' : ''">
            <div class="px-1 col-2">
                <basic-info></basic-info>
            </div>

            <div class="px-1 col-5">
                <small
                    >{{
                        moment()
                            .startOf("day")
                            .seconds(target.data.success || 0)
                            .format("H:mm:ss")
                    }}
                    <i
                        v-if="target.data.hasOwnProperty('results')"
                        class="cursor-pointer text-primary fa fa-lg fa-caret-right"
                        :class="{ 'rot-90': rowDetail }"
                        @click="rowDetail = !rowDetail"
                    ></i
                ></small>
            </div>
            <div class="px-1 col-1">
                <small>{{ target.data.results ? target.data.results.length : "N/A" }}</small>
            </div>
            <div class="px-1 col-1">
                <small>{{ target.progress }}%</small>
            </div>
            <div class="px-1 col-2">
                <small
                    ><span v-if="isBaseline" class="font-weight-bold text-uppercase text-primary"
                        >Baseline</span
                    >
                    {{ target.notes ? target.notes : "none" }}</small
                >
            </div>

            <div class="px-1 col-1">
                <data-actions
                    @delete-tracker="$emit('delete-tracker')"
                    @edit-target="$emit('edit-target', $event)"
                    @close-details="$emit('close-details')"
                ></data-actions>
            </div>
        </div>

        <div class="row pl-3 pr-1 data-row mx-0" v-if="rowDetail" style="border-top:none;">
            <div class="px-1 col-2 offset-2 d-flex flex-column">
                <div class="mb-0 d-flex" v-for="(r, i) in target.data.results">
                    <small class="text-nowrap mr-1">{{
                        `${i + 1} - ${moment()
                            .startOf("day")
                            .seconds(r || 0)
                            .format("H:mm:ss")}`
                    }}</small>

                    <intensity
                        v-if="target.data.intensity && target.data.intensity.length"
                        :mini="true"
                        :value="[target.data.iconset, target.data.intensity[i]]"
                    ></intensity>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Intensity from "../../ui/IntensityIcon";
import BasicInfo from "./BasicInfo";
import DataActions from "./DataActions";

export default {
    name: "TrackerDataDuration",
    inject: ["target", "isBaseline", "iconset"],
    data() {
        return {
            rowDetail: false,
        };
    },
    components: {
        Intensity,
        BasicInfo,
        DataActions,
    },
};
</script>
